import * as React from 'react';
import Button from '~/components/atoms/button/button';
import XMarkIcon from '~/components/atoms/icon/xMark/XMarkIcon';
import styles from './cancelFiltersButton.module.scss';

interface IClearBadges {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const CancelFilterButton: React.FC<IClearBadges> & React.HTMLAttributes<HTMLButtonElement> = ({
    onClick,
    ...buttonAttributes
}) => {
    return (
        <Button onclick={onClick} className={styles.cancelFilterButton} link={false} {...buttonAttributes}>
            <XMarkIcon width={18} height={18} />
        </Button>
    );
};

export default CancelFilterButton;
